import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TagCloud } from 'react-tagcloud';
import { Button, Container, Grid, Header, Segment } from 'semantic-ui-react';
import * as actions from '../../actions';

class Document extends Component {
  state = {
    keywordLimit: null,
  };

  render() {
    const { auth, content, handleSaveDocument } = this.props;
    const { keywordLimit } = this.state;

    const cloudData = content.keywords.map(item => ({ value: item.name, count: item.count }));

    if (!content) {
      return null;
    }

    const isSaved =
      auth.documents.filter(item => item._id.toString() === content._id).length !== 0;

    return (
      <Container text>
        <Header as="h2">{content.title}</Header>
        <Grid stackable columns={2}>
          <Grid.Column>
            {auth !== null &&
              auth !== false && (
                <Button
                  color={isSaved ? 'red' : 'green'}
                  basic={!isSaved}
                  content={isSaved ? 'Remover' : 'Salvar'}
                  icon={isSaved ? 'trash' : 'save'}
                  fluid
                  onClick={() => handleSaveDocument(content._id)}
                />
              )}
          </Grid.Column>
          <Grid.Column>
            <a href={content.url} target="_blank" rel="noopener noreferrer">
              <Button basic content="Fonte" icon="linkify" fluid />
            </a>
          </Grid.Column>
        </Grid>
        <Segment>
          <h4>{content.description}</h4>
        </Segment>
        <Button.Group attached="top">
          <Button positive={!keywordLimit} onClick={() => this.setState({ keywordLimit: null })}>
            Todas
          </Button>
          <Button.Or text="ou" />
          <Button positive={!!keywordLimit} onClick={() => this.setState({ keywordLimit: 10 })}>
            Top 10
          </Button>
        </Button.Group>
        <Segment style={{ backgroundColor: '#333' }}>
          <TagCloud
            tags={cloudData.slice(0, keywordLimit || cloudData.length)}
            maxSize={60}
            minSize={15}
            colorOptions={{ luminosity: 'light' }}
            style={{ textAlign: 'center' }}
          />
        </Segment>
        <Segment>
          <code>{content.text}</code>
        </Segment>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

Document.propTypes = {
  content: PropTypes.object,
  handleSaveDocument: PropTypes.func,
  auth: PropTypes.any,
};

export default connect(
  mapStateToProps,
  actions,
)(Document);



// WEBPACK FOOTER //
// ./src/components/Document/Document.js